import { render, staticRenderFns } from "./OffersCard.vue?vue&type=template&id=6aad977c&scoped=true&"
import script from "./OffersCard.vue?vue&type=script&lang=js&"
export * from "./OffersCard.vue?vue&type=script&lang=js&"
import style0 from "./OffersCard.vue?vue&type=style&index=0&id=6aad977c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad977c",
  null
  
)

export default component.exports